import { render, staticRenderFns } from "./Resume.vue?vue&type=template&id=7870b1b2"
import script from "./Resume.vue?vue&type=script&lang=js"
export * from "./Resume.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports